import React from 'react'
import { useGetHTL2026Point } from '../../api/point'
import { PointDetails } from '../shared/PointDetails'

export const HTL2026Point = () => {
  return (
    <PointDetails
      title='HTL 2026 Point'
      useGetPoint={useGetHTL2026Point}
      backLink={'htl-2026-point'}
      accountSummary={[]}
      purchaseHistory={[]}
    />
  )
}
